var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91683 1.41667H12.8335C13.1835 1.41667 13.4168 1.65 13.4168 2V17.1667C13.4168 17.5167 13.1835 17.75 12.8335 17.75H1.16683C0.816829 17.75 0.583496 17.5167 0.583496 17.1667V2C0.583496 1.65 0.816829 1.41667 1.16683 1.41667H4.0835V0.833333C4.0835 0.483333 4.31683 0.25 4.66683 0.25H9.3335C9.6835 0.25 9.91683 0.483333 9.91683 0.833333V1.41667ZM8.75024 1.41406H5.25024V2.58073H8.75024V1.41406ZM12.2502 16.5859H1.75024V2.58594H4.08358V3.16927C4.08358 3.51927 4.31691 3.7526 4.66691 3.7526H9.33358C9.68358 3.7526 9.91691 3.51927 9.91691 3.16927V2.58594H12.2502V16.5859ZM10.9087 8.60885C11.142 8.37552 11.142 8.02552 10.9087 7.79219C10.6753 7.55885 10.3253 7.55885 10.092 7.79219L5.83366 12.0505L3.90866 10.1255C3.67533 9.89219 3.32533 9.89219 3.09199 10.1255C2.85866 10.3589 2.85866 10.7089 3.09199 10.9422L5.42533 13.2755C5.54199 13.3922 5.65866 13.4505 5.83366 13.4505C6.00866 13.4505 6.12533 13.3922 6.24199 13.2755L10.9087 8.60885Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.faa1fd600da059c376b09c93a4b7937c.svg";
export { ForwardRef as ReactComponent };